interface FmbCheckListProps {
  items: string[];
  /** Uppercase-Label über der Liste — ohne Angabe entfällt es */
  label?: string;
}

/**
 * Liste weißer Karten mit Häkchen-Kreis. Genutzt von der Checkliste der
 * Landingpage (Sektion 03 und 05) und vom Lieferumfang auf der Videoseite.
 */
export default function FmbCheckList({ items, label }: FmbCheckListProps) {
  return (
    <div className="flex flex-col gap-4">
      {label !== undefined && (
        <div className="pb-2 text-[13px] font-bold tracking-[0.14em] uppercase text-[var(--fmb-label)]">{label}</div>
      )}
      {items.map((item) => (
        <div
          key={item}
          className="flex items-start gap-[18px] rounded-[14px] border border-[var(--fmb-border-card)] bg-white px-[26px] py-6"
        >
          <div className="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full bg-[var(--fmb-accent)] text-[15px] text-white">
            ✓
          </div>
          <div className="pt-0.5 text-[17px] leading-[1.6] text-[var(--fmb-card-text)]">{item}</div>
        </div>
      ))}
    </div>
  );
}
